// Module
var code = "<react-component name=\"PosDeliveriesReport\"></react-component>\n";
// Exports
module.exports = code;